import { env } from '@skin-seoul/env-utils';
import { cartClient } from '../common/cartClient';
import type {
  GetUserMeResponse,
  GetUserRequest,
  GetUserResponse,
  UpdateUserRequest,
  UpdateUserResponse,
} from './utils/types';

class UserAPIClient {
  public async getMe(): Promise<GetUserMeResponse> {
    if (env('NEXT_PUBLIC_ENV') === 'LOCAL') {
      return {
        userId: 725,
        userName: 'jason',
        email: 'jason@skin-seoul.com',
        displayName: 'jason',
      };
    }
    try {
      const res = await cartClient.get('/user/me');
      return res.data;
    } catch (_e) {
      return null;
    }
  }

  public async getUser(params: GetUserRequest): Promise<GetUserResponse> {
    if (env('NEXT_PUBLIC_ENV') === 'LOCAL') {
      return {
        userId: params.userId,
        email: { emailAddress: 'jason@skin-seoul.com', subscribed: false },
      };
    }
    try {
      const res = await cartClient.get('/user', { params });
      return res.data;
    } catch (_e) {
      return null;
    }
  }

  public async updateUser(payload: UpdateUserRequest): Promise<UpdateUserResponse> {
    const res = await cartClient.put('/user', payload);
    return res.data;
  }
}

export const userAPIClient = new UserAPIClient();
